import { useCallback } from 'react'
import { useHistory } from '@ztechapps/common.hook'
import { useKeyboardShortcut } from '@ztechapps/webui.util'
import { ShortcutDefaults } from '../../config/shortcutDefaults'
import { getWindow } from '@ztechapps/common.utils'

export const GlobalShortcuts = () => {
  const history = useHistory()

  const goToShortcutSettings = useCallback(() => {
    history.push('/app/settings?tab=Preferences&subtab=Keyboard+Shortcuts')
  }, [history])

  const focusSearch = useCallback(() => {
    const win = getWindow()
    if (!win) return
    const searchInput = win.document.querySelector<HTMLInputElement>('[data-shortcut-target="global-search"] input')
    searchInput?.focus()
  }, [])

  useKeyboardShortcut({ ...ShortcutDefaults.ShowHelp, action: goToShortcutSettings })
  useKeyboardShortcut({ ...ShortcutDefaults.FocusSearch, action: focusSearch })

  return null
}
